<template>
	<div class="content">
		
	</div>
</template>

<script>
export default {
	data() {
		return {
			
		}
	},
	created() {
		
	},
}
</script>

<style lang="less" scoped>
.main_page_content {
	width: 100%;
	overflow: hidden;
	background-image: url(~@/assets/images/bg1.png);
	background-size: cover;
	background-position: center center;
	padding: 1.68rem 0 .6rem 0;

	.m {
		width: 11.2rem;
		margin: 0 auto;

		.forum_list {
			width: 100%;
			overflow: auto;
			background: #EBEBEB;
			border-radius: .28rem;
			padding: .36rem .24rem 0 .64rem;

			ul {
				width: 100%;
				overflow: auto;
				max-height: 10rem;
				padding-right: .34rem;

				&::-webkit-scrollbar {
					width: 4px;
				}

				&::-webkit-scrollbar-track {
					background: #CFCFCF;
				}

				&::-webkit-scrollbar-thumb {
					background-color: #626262;
					border-radius: 20px;
				}

				li {
					border-bottom: 1px dashed #999999;
					width: 100%;

					a {
						display: flex;
						padding: .24rem 0;
						justify-content: space-between;
						box-sizing: border-box;

						.pic {
							width: 2.56rem;
							overflow: hidden;
							height: 1.44rem;
							border-radius: .2rem;

							img {
								display: block;
								width: 100%;
								height: 100%;
								object-fit: cover;
							}
						}

						.grow {
							overflow: hidden;
							width: calc(100% - 2.56rem - .4rem);
							position: relative;

							.bot {
								display: flex;
								align-items: center;
								position: absolute;
								left: 0;
								bottom: 0;
								width: 100%;

								img {
									border-radius: 50%;
									display: block;
									width: .14rem;
									min-width: 12px;
									margin-right: .08rem;
								}

								em {
									font-size: .16rem;
									color: #999999;
									font-family: syn;
								}
							}

							.des {
								display: flex;
								align-items: center;
								flex-wrap: wrap;

								span {
									display: inline-flex;
									align-items: center;
									height: .24rem;
									border-radius: .5rem;
									padding: 0 .12rem;
									font-size: .16rem;
									color: #666666;
									margin-right: .08rem;
									border: 1px solid #CBCCCC;
									line-height: 1;
									font-family: syn;
									margin-top: .16rem;
								}
							}

							p {
								font-size: .2rem;
								color: #222222;
								font-family: syb;
								line-height: .28rem;
							}
						}
					}
				}
			}
		}

		.match_title {
			overflow: hidden;
			.name {
				display: flex;
				margin-bottom: .32rem;
				align-items: center;
				div {
					width: .09rem;
					border-radius: 20px;
					background: #FC581C;
					margin-right: .27rem;
					height: .36rem;
				}

				span {
					font-size: .36rem;
					color: #fff;
					display: block;
					line-height: 1;
					font-family: syb;
					letter-spacing: .01rem;
				}
			}

			em {
				display: block;
				font-size: .2rem;
				color: #fff;
				line-height: 1;
				font-family: sy;
				letter-spacing: .01rem;
				padding-left: .4rem;
				margin-bottom: .2rem;
			}
		}
	}
}

@media screen and (min-width: 769px) {}

/* 媒体查询（手机） */

@media screen and (max-width: 900px) {
	.main_page_content {
		width: 100%;
		padding: 2.09rem .4rem 1rem .4rem;
	}
	.main_page_content .m .forum_list ul li a .grow .des{
		display: block;
		white-space: nowrap;
	}
	.main_page_content .m .match_title .name div {
		width: .12rem;
		height: .48rem;
		margin-right: .36rem;
	}

	.main_page_content .m .match_title .name span {
		font-size: .48rem;
		font-family: "微软雅黑";
		font-weight: bold;
	}

	.main_page_content .m .match_title em {
		font-size: .24rem;
		margin-top: .4rem;
		font-family: syn;
		padding-left: .44rem;
	}

	.left_navbar {
		display: none;
	}

	.main_page_content .m {
		width: 100% !important;
	}

	.main_page_content .m .forum_list ul li a {
		padding: .36rem 0;
		align-items: flex-start;

		.pic {
			width: 2.4rem;
			height: 1.35rem;
		}

		.grow {
			width: calc(100% - 2.4rem - .28rem);

			p {
				font-size: .24rem;
				line-height: .32rem;
			}

			.des span {
				height: .32rem;
				padding: 0 .18rem;
				font-size: .22rem;
				margin-right: .08rem;
				margin-top: .15rem;
			}

			.bot {
				position: static;
				margin-top: .2rem;

				img {
					width: .17rem;
					margin-right: .11rem;
				}

				em {
					font-size: .22rem;
				}
			}
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/pages/news_publish/news_publish.vue